import React from 'react';
import {Box, Stack, Typography, Divider} from '@mui/material';
import MuiDrawer, {drawerClasses} from '@mui/material/Drawer';
import {styled} from '@mui/material/styles';

const DRAWER_WIDTH = 240;

const StyledDrawer = styled(MuiDrawer)({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    boxSizing: 'border-box',
    [`& .${drawerClasses.paper}`]: {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box'
    }
});

export default function Sidebar({logo, siteName, children, userSection}) {
    return (
        <StyledDrawer variant="permanent">
            <Box sx={{mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {logo || (
                    <Typography variant="h6" noWrap>
                        {siteName}
                    </Typography>
                )}
            </Box>

            <Divider />

            <Stack sx={{flexGrow: 1, justifyContent: 'space-between', overflow: 'auto'}}>
                {children}
            </Stack>

            {userSection}
        </StyledDrawer>
    );
}
